import React, { useEffect, useState } from 'react';
import { Wrench, Clock } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || '/api';

const Maintenance = () => {
  const [maintenanceInfo, setMaintenanceInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    fetchMaintenanceInfo();
  }, []);

  const fetchMaintenanceInfo = async () => {
    try {
      const response = await axios.get(`${API}/maintenance-mode`);
      setMaintenanceInfo(response.data);
      
      // Si la maintenance est désactivée, rediriger vers la page de login
      if (!response.data.is_active) {
        window.location.href = '/login';
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des infos de maintenance:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCheckMaintenance = async () => {
    setChecking(true);
    await fetchMaintenanceInfo();
    setChecking(false);
  };

  const formatDate = (dateString) => {
    if (!dateString) return null;
    try {
      const date = new Date(dateString);
      return date.toLocaleString('fr-FR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }).replace(',', '');
    } catch {
      return dateString;
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#1a2332] flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#f4af14]"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#1a2332] flex items-center justify-center p-4">
      <div className="max-w-lg w-full">
        <div className="bg-[#1e2a3a] border border-[#2d3d4f] rounded-xl p-8 md:p-10">
          {/* Header avec icône et titre */}
          <div className="flex items-center gap-4 mb-8">
            <div className="bg-[#3d4a3a] rounded-full p-4">
              <Wrench className="w-8 h-8 text-[#f4af14]" />
            </div>
            <h1 className="text-2xl md:text-3xl font-bold text-white">
              Application en Maintenance
            </h1>
          </div>

          {/* Raison */}
          <div className="mb-6">
            <p className="text-gray-400 text-sm mb-2">Raison :</p>
            <p className="text-white text-lg">
              {maintenanceInfo?.reason || 'Maintenance en cours'}
            </p>
          </div>

          {/* Date de fin estimée */}
          {maintenanceInfo?.estimated_end && (
            <div className="flex items-start gap-3 mb-8">
              <Clock className="w-5 h-5 text-gray-400 mt-0.5" />
              <div>
                <p className="text-gray-400 text-sm">Retour prévu :</p>
                <p className="text-white text-lg">
                  {formatDate(maintenanceInfo.estimated_end)}
                </p>
              </div>
            </div>
          )}

          {/* Bouton de vérification */}
          <button
            onClick={handleCheckMaintenance}
            disabled={checking}
            className="w-full border border-gray-500 text-gray-300 hover:bg-[#2d3d4f] hover:text-white font-medium px-6 py-3 rounded-lg transition-colors disabled:opacity-50"
          >
            {checking ? 'Vérification...' : 'Vérifier si la maintenance est terminée'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Maintenance;
